
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import { Container, Draggable } from 'react-smooth-dnd';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Slider from '@material-ui/core/Slider';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";

import {
    sedimentDisasterHazardMapLayer,
    floodInundationHazardMapLayer,
    landslideLayer,
    inundationLayer,
    highResolutionNowcastLayer,
} from '../layers'


const useStyles = makeStyles(() => ({
    root: {
        height: '100vh',
        width: 900,
        backgroundColor: '#272727',
    },
    categoryBox: {
        color: '#EBEBEB',
    },
    dragableBox: {
        borderRadius: 5,
        borderColor: '#505050',
        color: '#EBEBEB',
    },
}));

function LayersBox(props) {
    const classes = useStyles();
    const { mapLayers, onDrop, onChange } = props;

    return (
        <Box className={classes.categoryBox} p={1} m={0.5} bgcolor={"#272727"}  >
            <Typography variant="h2" >レイヤー</Typography>
            <Container dragHandleSelector=".column-drag-handle" onDrop={e => onDrop(e)}>
                {mapLayers.map((x, i) => (
                    <Draggable key={x.title}>
                        <Box className={classes.dragableBox} px={1.0} py={0} m={.3} bgcolor="#353535" border={1} >
                            <FormControlLabel
                                control={<Checkbox
                                    key={x.title}
                                    checked={x.isShow}
                                    onChange={e => onChange(i, e.target.checked)}
                                    color="primary" />}
                                label={x.title}
                            />
                            <span className="column-drag-handle" style={{ float: 'right', padding: '10px 10px' }}>&#x2630;</span>
                        </Box>
                    </Draggable>
                ))}
            </Container>
        </Box>
    );
};

function LandslideLayerBox(props) {
    const classes = useStyles();
    const { opacity, onChangeOpacity } = props;

    return (
        <Box className={classes.categoryBox} p={1} m={0.5} bgcolor="#272727" borderColor="gray">
            <Typography variant="h2">キキクル 土砂災害 要素</Typography>

            <Box px={1} pt={0.5}>
                <Grid container spacing={2}>
                    <Grid item>透明度</Grid>
                    <Grid item xs>
                        <Slider
                            disabled={!landslideLayer.isShow}
                            width={50}
                            value={opacity}
                            onChange={onChangeOpacity}
                            aria-labelledby="continuous-slider" />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};


function InundationLayerBox(props) {
    const classes = useStyles();
    const { opacity, onChangeOpacity } = props;

    return (
        <Box className={classes.categoryBox} p={1} m={0.5} bgcolor="#272727" borderColor="gray">
            <Typography variant="h2">キキクル 浸水害 要素</Typography>

            <Box px={1} pt={0.5}>
                <Grid container spacing={2}>
                    <Grid item>透明度</Grid>
                    <Grid item xs>
                        <Slider
                            disabled={!inundationLayer.isShow}
                            width={50}
                            value={opacity}
                            onChange={onChangeOpacity}
                            aria-labelledby="continuous-slider" />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};


function HighResolutionNowcastLayerBox(props) {
    const classes = useStyles();
    const { opacity, onChangeOpacity } = props;

    return (
        <Box className={classes.categoryBox} p={1} m={0.5} bgcolor="#272727" borderColor="gray">
            <Typography variant="h2">高解像度降水ナウキャスト要素</Typography>

            <Box px={1} pt={0.5}>
                <Grid container spacing={2}>
                    <Grid item>透明度</Grid>
                    <Grid item xs>
                        <Slider
                            disabled={!highResolutionNowcastLayer.isShow}
                            width={50}
                            value={opacity}
                            onChange={onChangeOpacity}
                            aria-labelledby="continuous-slider" />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};


function FloodInundationHazardMapBox(props) {
    const classes = useStyles();
    const { onDropElement, onChangeElement, elements, opacity, onChangeOpacity } = props;

    return (
        <Box className={classes.categoryBox} p={1} m={0.5} bgcolor="#272727" borderColor="gray">
            <Typography variant="h2">洪水浸水ハザードマップ要素</Typography>
            <Container dragHandleSelector=".column-drag-handle" onDrop={e => onDropElement(e)}>
                {elements.map((x, i) => (
                    <Draggable key={x.title}>
                        <Box className={classes.dragableBox} px={1.0} py={0} m={.3} bgcolor="#353535" border={1} borderColor="lightgray">
                            <FormControlLabel
                                control={<Checkbox
                                    checked={x.element.isShow}
                                    onChange={e => onChangeElement(i, e.target.checked)}
                                    color="primary"
                                    disabled={!floodInundationHazardMapLayer.isShow} />}
                                label={x.title}
                            />
                            <span className="column-drag-handle" style={{ float: 'right', padding: '10px 10px' }}>&#x2630;</span>
                        </Box>
                    </Draggable>
                ))}
            </Container>

            <Box px={1} pt={0.5}>
                <Grid container spacing={2}>
                    <Grid item>透明度</Grid>
                    <Grid item xs>
                        <Slider
                            disabled={!floodInundationHazardMapLayer.isShow}
                            value={opacity}
                            onChange={onChangeOpacity}
                            aria-labelledby="continuous-slider" />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};



function SedimentDisasterHazardMapBox(props) {
    const classes = useStyles();
    const { onDropElement, onChangeElement, elements, opacity, onChangeOpacity } = props;

    return (
        <Box className={classes.categoryBox} p={1} m={0.5} bgcolor="#272727" borderColor="gray">
            <Typography variant="h2">土砂災害ハザードマップ要素</Typography>
            <Container dragHandleSelector=".column-drag-handle" onDrop={e => onDropElement(e)}>
                {elements.map((x, i) => (
                    <Draggable key={x.title}>
                        <Box className={classes.dragableBox} px={1.0} py={0} m={.3} bgcolor="#353535" border={1} borderColor="lightgray">
                            <FormControlLabel
                                control={<Checkbox
                                    checked={x.element.isShow}
                                    onChange={e => onChangeElement(i, e.target.checked)}
                                    color="primary"
                                    disabled={!sedimentDisasterHazardMapLayer.isShow} />}
                                label={x.title}
                            />
                            <span className="column-drag-handle" style={{ float: 'right', padding: '10px 10px' }}>&#x2630;</span>
                        </Box>
                    </Draggable>
                ))}
            </Container>

            <Box px={1} pt={0.5}>
                <Grid container spacing={2}>
                    <Grid item>透明度</Grid>
                    <Grid item xs>
                        <Slider
                            disabled={!sedimentDisasterHazardMapLayer.isShow}
                            width={50}
                            value={opacity}
                            onChange={onChangeOpacity}
                            aria-labelledby="continuous-slider" />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};



export function ControlPanel(props) {
    const classes = useStyles();
    const { mapLayers, opacities, elements, handlers } = props;

    return (
        <Box className={classes.root} >
            <Grid container>
                <Grid item xs={5}>
                    <LayersBox
                        classes={classes}
                        mapLayers={mapLayers}
                        onDrop={handlers.onDropLayer}
                        onChange={handlers.onChangeLayer} />
                </Grid>

                <Grid item xs={7}>
                    <LandslideLayerBox
                        classes={classes}
                        mapLayers={mapLayers}
                        opacity={opacities.landslideLayer}
                        onChangeOpacity={handlers.onChangeLandslideLayerOpacity} />

                    <InundationLayerBox
                        classes={classes}
                        opacity={opacities.inundationLayer}
                        onChangeOpacity={handlers.onChangeInundationLayerOpacity} />

                    <HighResolutionNowcastLayerBox
                        classes={classes}
                        opacity={opacities.highResolutionNowcastLayer}
                        onChangeOpacity={handlers.onChangeHighResolutionNowcastLayerOpacity} />

                    <FloodInundationHazardMapBox
                        classes={classes}
                        elements={elements.floodInundationHazardMap}
                        opacity={opacities.floodInundationHazardMap}
                        onDropElement={handlers.onDropFloodInundationElement}
                        onChangeElement={handlers.onChangeFloodInundationHazardMapElement}
                        onChangeOpacity={handlers.onChangeFloodInundationHazardMapOpacity} />

                    <SedimentDisasterHazardMapBox
                        classes={classes}
                        elements={elements.sedimentDisasterHazardMap}
                        opacity={opacities.sedimentDisasterHazardMap}
                        onDropElement={handlers.onDropSedimentDisasterElement}
                        onChangeElement={handlers.onChangeSedimentDisasterHazardMapElement}
                        onChangeOpacity={handlers.onChangeSedimentDisasterHazardMapOpacity} />
                </Grid>
            </Grid>

            <Box px={2.0} py={1.0}  >
                <Button fullWidth variant="contained" color="primary" onClick={handlers.onClosePanel}>
                    閉じる
                </Button>
            </Box>
        </Box>
    );
};

export default ControlPanel;
